
define(
	'Code25.CaterpartsGlobal.CloseAccount'
	, [
		"Utils",'Code25.CaterpartsGlobal.CloseAccount.View','Backbone'
	]
	, function (
		Utils,CloseAccountView,Backbone
	) {
		'use strict';
		return {
			mount: function mount(container) {

				var MyAccountMenu=require("MyAccountMenu");
				if(MyAccountMenu.MyAccountMenu){
					MyAccountMenu=MyAccountMenu.MyAccountMenu;
				}
				var myAccountMenu = MyAccountMenu.getInstance();
				
				myAccountMenu.addSubEntry({
					entryId: 'settings',
					id: 'closeaccount',
					name: Utils.translate('Close Account'),
					url: 'closeaccount',
					index: 7
				});

				var router= Backbone.Router.extend({
					initialize: function (application) {
						this.application = application;
					},
					routes: {
						'closeaccount': 'CloseAccount',
					},
					CloseAccount: function () {
						var view = new CloseAccountView({application:container});
						view.showContent();
					}
				});

				return new router(container);


			}

		}

	});
